var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalfHexRivetNut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st7,.st8{fill:none;stroke:#414042;stroke-width:1.4454;stroke-miterlimit:10}.st8{stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 74.923,
    x2: 202.024,
    y1: 178.222,
    y2: 178.222,
    gradientTransform: "matrix(1.0175 0 0 1 -2.646 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    style: {
      stopColor: "#a7a9ac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    style: {
      stopColor: "#b5b7b9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#d9dadc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    style: {
      stopColor: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#cfd0d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    style: {
      stopColor: "#c1c3c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#bcbec0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.59 178.22c0-24.46 28.95-44.28 64.66-44.28s64.66 19.83 64.66 44.28-28.95 44.28-64.66 44.28-64.66-19.82-64.66-44.28",
    style: {
      fill: "url(#SVGID_1_)",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000064348781250989649830000008508427281338718610_",
    cx: 138.403,
    cy: 173.877,
    r: 54.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.85 173.88c0-24.46 28.45-44.28 63.55-44.28s63.55 19.83 63.55 44.28-28.45 44.28-63.55 44.28-63.55-19.83-63.55-44.28",
    style: {
      fill: "url(#SVGID_00000064348781250989649830000008508427281338718610_)",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061464466465129086720000001386466000957810052_",
    x1: 95.146,
    x2: 181.757,
    y1: 148.326,
    y2: 148.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.71 146.52c-.12-21.69-21.48 11.38-21.48 20.93h-.01s-3.04-14.07-21.53-14.07c-18.12 0-21.77 14.07-21.77 14.07 0-9.55-21.56-42.62-21.68-20.93 0 0-1.12-11.32 4.9-17.31h75.91c-.01 0 6.3 6.92 5.66 17.31z",
    style: {
      fill: "url(#SVGID_00000061464466465129086720000001386466000957810052_)",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034805962295378902360000002416273925933952148_",
    x1: 100.497,
    x2: 176.406,
    y1: 100.23,
    y2: 100.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.16 51.17c13.79 7.14 15.64 19.74 15.64 19.74l.61 59.35s-8.14 19.03-37.95 19.03-37.95-20.08-37.95-20.08V71.32s1.95-12.72 15.74-19.86",
    style: {
      fill: "url(#SVGID_00000034805962295378902360000002416273925933952148_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.06 70.48c0 13.48-16.03 24.46-35.67 24.46s-35.56-10.93-35.56-24.4 15.92-24.4 35.56-24.4S174.06 57 174.06 70.48z",
    style: {
      fill: "#d1d3d4",
      stroke: "#000",
      strokeWidth: 1.4227,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142885747082221254000000008730305206092889475_",
    x1: 138.452,
    x2: 138.452,
    y1: 89.881,
    y2: 58.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    style: {
      stopColor: "#626365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    style: {
      stopColor: "#86888a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    style: {
      stopColor: "#939598"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.92 69.85c0 10.52-13.72 19.09-30.52 19.09s-30.42-8.53-30.42-19.05 13.62-19.05 30.42-19.05 30.52 8.49 30.52 19.01z",
    style: {
      fill: "url(#SVGID_00000142885747082221254000000008730305206092889475_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.46 73.89c0 8.31-11.71 15.08-26.05 15.08s-25.97-6.74-25.97-15.05 11.63-15.05 25.97-15.05 26.05 6.71 26.05 15.02z",
    className: "st7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.38 85.8c-4.84-2.22-7.91-5.06-7.91-8.64 0-6.71 10.72-12.15 23.94-12.15s24.02 5.41 24.02 12.13c0 1.81-.79 3.53-2.2 5.08",
    className: "st7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.67 79.71c0 5.08-9.55 9.22-21.25 9.22s-21.18-4.12-21.18-9.2 9.48-9.2 21.18-9.2 21.25 4.1 21.25 9.18z",
    className: "st7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.72 83.77c0-4.49 8.37-8.12 18.71-8.12 10.33 0 18.76 3.62 18.76 8.1",
    className: "st7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.92 69.85c0 10.52-13.72 19.09-30.52 19.09s-30.42-8.53-30.42-19.05 13.62-19.05 30.42-19.05 30.52 8.49 30.52 19.01z",
    className: "st8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.16 51.17c13.79 7.14 15.64 19.74 15.64 19.74h0l.61 59.35s-8.14 19.03-37.95 19.03-37.95-20.08-37.95-20.08V71.32s1.95-12.72 15.74-19.86",
    className: "st8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158029540309019079600000014904197020987846301_",
    x1: 160.209,
    x2: 181.694,
    y1: 169.008,
    y2: 169.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.22 174.67s.48-3.89.48-28.26c-.12-21.69-21.48 11.38-21.48 20.93 0 7.06.19 31.51.19 31.51l20.81-24.18z",
    style: {
      fill: "url(#SVGID_00000158029540309019079600000014904197020987846301_)",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044857713602923310040000018040320277736471971_",
    x1: 95.21,
    x2: 116.892,
    y1: 168.964,
    y2: 168.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.69 174.67s-.48-3.89-.48-28.26c.12-21.69 21.68 11.38 21.68 20.93v31.42l-21.2-24.09z",
    style: {
      fill: "url(#SVGID_00000044857713602923310040000018040320277736471971_)",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090289227879937530760000008466862439783095202_",
    x1: 116.892,
    x2: 160.403,
    y1: 176.055,
    y2: 176.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7c7e80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#6d6e71"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.89 198.76v-31.42s3.65-14.07 21.77-14.07c18.49 0 21.53 14.07 21.53 14.07l.21 31.51-43.51-.09z",
    style: {
      fill: "url(#SVGID_00000090289227879937530760000008466862439783095202_)",
      stroke: "#000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfHexRivetNut);
export default __webpack_public_path__ + "static/media/Half_Hex_Rivet_Nut.0fc42358ced36f2138af232b1a809da2.svg";
export { ForwardRef as ReactComponent };